import script from "./WatermarkControl.vue?vue&type=script&setup=true&lang=js"
export * from "./WatermarkControl.vue?vue&type=script&setup=true&lang=js"

import "./WatermarkControl.vue?vue&type=style&index=0&id=80eea9be&scoped=true&lang=css"

import exportComponent from "/home/passani/git_repos/onlineimageoptimizer.com/image-optimizer-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80eea9be"]])

export default __exports__